import React from 'react'
import { styled } from 'styled-components'
import { NavigationMap as NavigationMapViewer } from '@mission.io/navigation-map-client'
import {
	useResolvers,
	useIsDebugging,
	getNavigationMapData,
	useMissionStateSelector,
} from '../../../context'
import { useSendWebsocketMessage } from '../../../context/provider.jsx'
import { getMetricsWebsocketMessage } from '../../../context/metrics'

export default function NavigationScreen({
	teacherView,
}: {
	teacherView: boolean,
}): React$Node {
	const { navigationSourceResolver } = useResolvers()
	const navigationMapData = useMissionStateSelector(getNavigationMapData)
	const isDebugging = useIsDebugging()
	const sendWebsocketMessage = useSendWebsocketMessage()

	if (teacherView) {
		return (
			<TeacherNavigationWrapper>
				<TeacherNavigationDiv>
					{navigationMapData
						? 'Navigation Map on Main Screen'
						: 'Loading Navigation Map'}
				</TeacherNavigationDiv>
			</TeacherNavigationWrapper>
		)
	}

	if (!navigationMapData) {
		return <NavigationDiv>Looking for Camerabot</NavigationDiv>
	}

	return (
		<StyledNavigationMapViewer
			debugging={isDebugging}
			shouldReset={false}
			clientState={navigationMapData}
			urlResolver={navigationSourceResolver}
			onReportMetrics={metrics =>
				sendWebsocketMessage(getMetricsWebsocketMessage(metrics))
			}
		/>
	)
}

const NavigationDiv = styled.div`
	width: 100%;
	color: white;

	display: flex;
	justify-content: center;
`

const StyledNavigationMapViewer = styled(NavigationMapViewer)`
	width: 100%;
`

const TeacherNavigationWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`

const TeacherNavigationDiv = styled.div`
	color: white;
	font-size: 10em;
`
